import { Component } from '@verndale/core';
import Swiper, { Navigation, Keyboard } from 'swiper';
import 'swiper/css/bundle';
import { BREAKPOINTS } from '../helpers/breakpoints';
import { DataLayerObject, ExtendedWindowType } from '../helpers/global-types';

class TestimonialCarousel extends Component {
  private touch = false;

  constructor(el: HTMLElement) {
    super(el);
  }

  setupDefaults() {
    this.dom = {
      el: this.el,
      swiperContainer: this.el.querySelector<HTMLElement>('.swiper-container'),
      swiperWrapper: this.el.querySelector<HTMLElement>('.swiper-wrapper'),
      swiperItems: this.el.querySelectorAll<HTMLElement>(
        '.testimonial-carousel__item'
      ),
      nextArrow: this.el.querySelector<HTMLElement>('.swiper-button-next'),
      prevArrow: this.el.querySelector<HTMLElement>('.swiper-button-prev'),
      carouselDotsContainer: this.el.querySelector<HTMLElement>(
        '.testimonial-carousel__swiper-pagination'
      )
    };

    this.addSliderDots();
    this.initSwiper();
  }

  addSliderDots() {
    const totalDots = (this.dom.swiperItems as NodeList)?.length || 0;

    if (totalDots <= 1) return;

    (this.dom.swiperItems as NodeList).forEach((item, index) => {
      const content = (item as HTMLElement).querySelector<HTMLElement>(
        '.testimonial-card__content'
      );
      let dots = '<div class="testimonial-card__pagination-indicator">';
      let carouselDots =
        '<div class="testimonial-carousel__pagination-indicator">';
      for (let i = 0; i < totalDots; i++) {
        dots += `<span class="testimonial-card__pagination-bullet ${
          i === index ? 'active' : ''
        }" data-index="${index}"></span>`;
        carouselDots += `<span class="testimonial-carousel__pagination-bullet ${
          i === 0 ? 'active' : ''
        }" data-index="${index}"></span>`;
      }
      dots += '</div>';
      carouselDots += '</div>';

      (content as HTMLElement).innerHTML += dots;
      if (index === 0) {
        (this.dom.carouselDotsContainer as HTMLElement).innerHTML +=
          carouselDots;
      }
    });
  }

  initSwiper() {
    Swiper.use([Navigation, Keyboard]);

    new Swiper(this.dom.swiperContainer as HTMLElement, {
      spaceBetween: 10,
      slidesPerView: 1,
      autoHeight: true,
      navigation: {
        prevEl: this.dom.prevArrow as HTMLElement,
        nextEl: this.dom.nextArrow as HTMLElement
      },
      effect: 'slide',
      speed: 500,
      breakpoints: {
        [BREAKPOINTS.tablet]: {
          spaceBetween: 20
        },
        [BREAKPOINTS.tabletLandscape]: {
          spaceBetween: 28
        }
      },
      on: {
        slideChange: swiper => this.handleSlideChange(swiper),
        touchEnd: () => (this.touch = true),
        click: () => (this.touch = false)
      },
      keyboard: {
        enabled: true,
        onlyInViewport: true
      }
    });
  }

  swiperLayerEvent(swiper: Swiper) {
    const interactLayer = `{"event":"carousel_interaction","event_action":"${
      this.touch ? 'swipe' : 'arrow click'
    }","event_category":"content_interaction","event_label":"${(
      swiper.activeIndex + 1
    ).toString()} of ${swiper.slides.length}"}`;

    if (interactLayer) {
      (window as ExtendedWindowType).dataLayer.push(
        JSON.parse(interactLayer) as DataLayerObject
      );
    }
  }

  handleSlideChange(swiper: Swiper) {
    this.swiperLayerEvent(swiper);
    (
      (this.dom.carouselDotsContainer as HTMLElement).querySelectorAll(
        '.testimonial-carousel__pagination-bullet'
      ) as NodeList
    ).forEach((item, index) => {
      if (index === swiper.activeIndex) {
        (item as HTMLElement).classList.add('active');
      } else {
        (item as HTMLElement).classList.remove('active');
      }
    });
  }
}

export default TestimonialCarousel;
